export enum ForYouModalStep {
    REGION = 1,
    CRITERIA = 2,
    USER = 3,
    SUCCESS = 4,
    ADDITIONAL = 5,
    SUMMARY = 6
}
